import { create, Cache } from '@tv2/lib-graphql/core/cache';
import { createClient as createClientShared, QueryClient } from '@tv2/lib-graphql/core';

const baseHeaders = (accessToken: string | null, isAdmin: boolean) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Client-Platform': `Web`,
  'Client-Platform-Class': '',
  'Client-Platform-Audience': 'PLAY',
  'Client-Platform-AppVersion': `${process.env.APP_VERSION}`,
  ...(accessToken ? { authorization: `Bearer ${accessToken}` } : {}),
  ...(isAdmin ? { 'Client-Platform-Role': `admin` } : {}),
});

export type CreateClientOptions = {
  url: string;
  accessToken?: string | null;
  initialCache?: Cache | null;
  ready?: boolean;
  updateAccessToken?: () => void;
  isAdmin?: boolean;
};

export function createClient({
  url,
  accessToken = null,
  initialCache = null,
  ready = false,
  updateAccessToken = () => {},
  isAdmin = false,
}: CreateClientOptions): QueryClient {
  return createClientShared({
    operationPrefix: 'play_web_content_',
    cache: initialCache ?? create(),
    isOnline: true,
    ready,
    url,
    requestPolicy: 'cache-and-network',
    shouldRetry: (resp, retries) => {
      if (updateAccessToken) {
        const [error] = resp.error.graphQLErrors ?? [];
        const errorType = error?.data?.type ?? error?.extensions?.code;
        if (
          errorType === 'InvalidAuthToken' ||
          errorType === 'RefreshToken' ||
          errorType === 'UNAUTHENTICATED' ||
          errorType === 'INVALID_JWT' ||
          errorType === 'AUTH_ERROR' ||
          resp?.error?.response?.status === 401
        ) {
          updateAccessToken();
        }
      }
      return retries === 0;
    },
    getHeaders() {
      return Promise.resolve(baseHeaders(accessToken, isAdmin));
    },
  });
}
